import { render, staticRenderFns } from "./ly-index.vue?vue&type=template&id=558b7121&scoped=true"
import script from "./ly-index.vue?vue&type=script&lang=js"
export * from "./ly-index.vue?vue&type=script&lang=js"
import style0 from "./index.scss?vue&type=style&index=0&id=558b7121&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558b7121",
  null
  
)

export default component.exports